import Live from './LiveConsumption';
export default Live;